import React from 'react';
import ReactDOM from 'react-dom/client';

console.log('🚀 index.tsx INICIANDO...');

// Log imediato
window.addEventListener('DOMContentLoaded', () => {
  console.log('✅ DOM carregado');
});

// Tratamento de erro global
window.addEventListener('error', (event) => {
  console.error('❌ ERRO GLOBAL:', event.error);
  const root = document.getElementById('root');
  if (root) {
    root.innerHTML = `
      <div style="padding: 40px; text-align: center; font-family: Arial;">
        <h1 style="color: red;">Erro: ${event.error?.message || 'Erro desconhecido'}</h1>
        <button onclick="location.reload()" style="margin-top: 20px; padding: 10px 20px; background: #dc2626; color: white; border: none; border-radius: 8px; cursor: pointer;">
          Recarregar
        </button>
      </div>
    `;
  }
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('❌ PROMISE REJEITADA:', event.reason);
});

// Importar App dinamicamente
import('./App').then(({ default: App }) => {
  console.log('✅ App importado');
  
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    console.error('❌ Root element não encontrado!');
    document.body.innerHTML = '<h1 style="color:red;padding:40px;text-align:center;">Erro: elemento root não encontrado</h1>';
    return;
  }

  console.log('✅ Root element encontrado');

  try {
    const root = ReactDOM.createRoot(rootElement);
    console.log('✅ ReactDOM.createRoot criado');
    
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    
    console.log('✅ App renderizado com sucesso!');
  } catch (error: any) {
    console.error('❌ Erro ao renderizar:', error);
    rootElement.innerHTML = `
      <div style="padding: 40px; text-align: center; font-family: Arial; max-width: 800px; margin: 0 auto;">
        <h1 style="color: red; font-size: 24px; margin-bottom: 20px;">Erro ao renderizar</h1>
        <p style="color: #666; margin-bottom: 20px;">${error?.message || String(error)}</p>
        <button onclick="location.reload()" style="margin-top: 20px; padding: 10px 20px; background: #dc2626; color: white; border: none; border-radius: 8px; cursor: pointer;">
          Recarregar Página
        </button>
      </div>
    `;
  }
}).catch((error) => {
  console.error('❌ Erro ao importar App:', error);
  const root = document.getElementById('root');
  if (root) {
    root.innerHTML = `
      <div style="padding: 40px; text-align: center; font-family: Arial;">
        <h1 style="color: red;">Erro ao carregar App</h1>
        <p>${error?.message || String(error)}</p>
        <button onclick="location.reload()" style="margin-top: 20px; padding: 10px 20px; background: #dc2626; color: white; border: none; border-radius: 8px; cursor: pointer;">
          Recarregar
        </button>
      </div>
    `;
  }
});

console.log('🚀 index.tsx FINALIZADO - aguardando imports...');
